import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'mat-intro-helper',
  templateUrl: './mat-intro-helper.component.html',
  styleUrls: ['./mat-intro-helper.component.scss']
})
export class MatIntroHelperComponent implements AfterViewInit {

    @Input() class: string = "";
    @Output() onClick: EventEmitter<void> = new EventEmitter();

    constructor(private elementRef: ElementRef) {}

    // Math.round((index ?? 0) / ((length - 1) || 1) * 100)

    ngAfterViewInit(): void {
        setTimeout(() => this.clearPing(), 9750);
    }

    clearPing() {
        this.elementRef.nativeElement.querySelector('button')?.classList.remove('intro-ping')
    }
}
